<template>
  <main>
    <section class="container-lil flex flex-col align-items-center">

      <h1 class="secondary-font text-5xl text-center mt-5 mb-7">
        Discuter avec <br/>un conseiller client
      </h1>

      <div class="flex-center">
        <img src="/public/assets/tchat/600w/avatar.jpg" class="size-3xl rounded-100 mx-2 my-2" alt="Conseiller client" />
        <img src="/public/assets/tchat/600w/avatar2.jpg" class="size-3xl rounded-100 mx-2 my-2" alt="Conseiller client" />
        <img src="/public/assets/tchat/600w/avatar3.jpg" class="size-3xl rounded-100 mx-2 my-2" alt="Conseiller client" />
      </div>
      <div class="flex-center">
        <img src="/public/assets/tchat/600w/avatar4.jpg" class="size-3xl rounded-100 mx-2 my-2" alt="Conseiller client" />
        <img src="/public/assets/tchat/600w/avatar5.jpg" class="size-3xl rounded-100 mx-2 my-2" alt="Conseiller client" />
        <img src="/public/assets/tchat/600w/avatar6.jpg" class="size-3xl rounded-100 mx-2 my-2" alt="Conseiller client" />
      </div>

      <a :href="`tel:${phoneNumberClean}`">
        <h1 class="text-4xl secondary-font text-grey-800 my-8">
          {{ phoneNumber }}
        </h1>
      </a>

      <a :href="`tel:${phoneNumberClean}`">
        <button class="btn lg btn-chatbot flex-center px-10 gap-2">
          <img src="/public/icons/icon-aide-appel.svg" class="btn-icon" alt="" />
          <span>Appelez maintenant</span>
        </button>
      </a>

      <div class="clear-both h-70"></div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import communicationService from '@/services/communicationService'

export default defineComponent({
  name: 'ServiceClientView',
  setup() {
    const config = communicationService.getConfig()
    // Utiliser le numéro du service ou celui du HTML par défaut
    const phoneNumber = config.phoneNumber || '+225 21 55 33 66 22'
    
    // Nettoyer le numéro pour le lien tel: (garder le + mais enlever les espaces)
    const phoneNumberClean = computed(() => {
      return phoneNumber.replace(/\s/g, '')
    })

    return {
      phoneNumber,
      phoneNumberClean
    }
  }
})
</script>

<style scoped>
/* Les styles globaux sont déjà définis dans les fichiers CSS globaux */
</style>

